/**
 * 認証、認可情報の getters
 */
const getters = {
};

export { getters as default };
